import React from 'react'
import { Avatar } from 'transfix-ui/components/Avatar'
import makeStyles from 'transfix-ui/core/styles/makeStyles'
import { Tooltip } from 'transfix-ui'

const useStyles = makeStyles(theme => ({
  avatar: {
    marginRight: theme.spacing(0.5),
  },
  shadow: {
    boxShadow: '0px 0',
  },
}))

interface IRequestedByAvatarProps {
  firstName?: string | null
  lastName?: string | null
  userType?: string | null
  fullName?: string | null
}

export const RequestedByAvatar = ({
  firstName,
  fullName,
  lastName,
  userType,
}: IRequestedByAvatarProps) => {
  let name = '?'
  let details = 'User is unknown'
  const classes = useStyles()

  if (typeof firstName === 'string' && typeof lastName === 'string') {
    name = [firstName, lastName].join(' ')
    details = name
  }

  if (typeof fullName === 'string') {
    name = fullName
  }

  if (userType === 'system' || userType === 'shipper') {
    return (
      <Tooltip
        position='right'
        trigger={
          <span className={classes.avatar}>
            <Avatar details={details} size='xsmall' hideTooltip />
          </span>
        }>
        {name}
      </Tooltip>
    )
  }

  return (
    <Tooltip
      position='right'
      trigger={
        <span className={classes.avatar}>
          <Avatar
            name={name}
            details={details}
            size='xsmall'
            className={classes.shadow}
            hideTooltip
          />
        </span>
      }>
      {name}
    </Tooltip>
  )
}
